import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledPageHeader = styled.header<{ $fullWidth?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  margin: 0 auto ${tvar('space.x4')};
  max-width: ${({ theme, $fullWidth }) =>
    $fullWidth ? 'none' : theme.measures.content.constrained};
`;

export const StyledLogo = styled.img`
  display: block;
  height: calc(6.4rem - ${tvar('space.double')});

  @media (min-width: ${tvar('measures.breakpoints.tabletSm')}) {
    height: calc(8rem - ${tvar('space.double')});
  }
`;
